<template>
  <router-view :search-token="searchToken"></router-view>
</template>

<script>
export default {
  name: 'ContentHolder',
  props: {
    searchToken: String,
  },
};
</script>
